import React, {
    useContext, useCallback, useEffect, useRef, Fragment, useState
} from 'react';
import _, { update } from 'lodash';
import PropTypes, { array } from 'prop-types';
import classNames from 'classnames';
import { withRouter } from 'react-router-dom';
import { TranslatorContext } from '@jutro/locale';
import { BreakpointTrackerContext } from '@jutro/layout';
import { ServiceManager } from '@jutro/services';
import { PhoneNumber } from 'gw-components-platform-react';
import {
    Button,
    InputField,
    Icon,
    Link,
    Chevron,
    IconButton,
    ModalNextProvider,
    CheckboxField,
    DateField,
    DropdownSelectField,
    TextAreaField
} from '@jutro/components';
import { useValidation } from 'gw-portals-validation-react';
import { useDependencies } from 'gw-portals-dependency-react';
import { useAuthentication } from 'gw-digital-auth-react';
import { readViewModelValue } from 'gw-jutro-adapters-react';
import { ViewModelServiceContext, ViewModelForm } from 'gw-portals-viewmodel-react';
import { WizardPage, wizardProps, WizardPageTemplate } from 'gw-portals-wizard-react';
import { fnolCommonMessages, VehicleDamagePicker } from 'gw-capability-fnol-common-react';
// eslint-disable-next-line import/no-unresolved
import config from 'app-config';
import FNOLCAContactItemComponent from '../../components/CAContactItemComponent/CAContactItemComponent';
import messages from '../../FNOLCA.messages';
import metadata from './VehiclesPage.metadata.json5';
import caClaimStyles from './VehiclesPage.module.scss';
import vehicleUtils from './vehicleUtils';
import Address from '../../../gw-capability-fnol-common-react/models/Address';
import LossCauseUtil from '../What/LossCauseUtil';
import DateUtil from '../../../../modules/gw-portals-util-js/DateUtil';
import Vehicle from '../../../gw-capability-fnol-common-react/models/Vehicle';

const displayableVehicleProperties = ['licensePlate', 'make', 'model', 'year'];

function FNOLCAVehiclesPage(props) {
    const { FNOLService } = useDependencies('FNOLService');
    const { AddressLookupService } = useDependencies('AddressLookupService');
    const breakpoint = useContext(BreakpointTrackerContext);
    const localeService = ServiceManager.getService('locale-service');
    const translator = useContext(TranslatorContext);
    const { wizardData: claimVM, updateWizardData } = props;
    const ismotorClaim = useRef(false);
    const convictionCodeList = useRef(null);
    const [selectedAddressList, updateSelectedAddressList] = useState([]);
    const [vehicleList, updateVehicleList] = useState([]);
    const [lookupResult_Ext, updatelookupResult_Ext] = useState(null);
    const [showLookupResult_Ext, updateShowLookupResult_Ext] = useState(false);
    const [showPostCodeLoader, updateshowPostCodeLoader] = useState(false);
    const [isVehicleChosen, updateIsVehicleChosen] = useState(true);
    const [carWebError, setcarWebError] = useState([]);
    const vehicleUseDropdownList = useRef(null);
    const vehicleStatusDropdownList = useRef(null);
    const isApplicableForPolicySection_Ext = useRef(false);
    const yesNoTbcOptions = useRef(null);
    const errorMessages = useRef([{ carWebLookup: '' }]);
    const isTheftOrGlassLossCause = useRef(false);
    const county = useRef(null);
    const selectAllOption = useRef([false]);
    const { oldestCarYear } = config.commercialAutoConfig;
    const viewModelService = useContext(ViewModelServiceContext);
    const { authHeader } = useAuthentication();

    const newContact = {
        placeholder: true
    };
    const {
        onValidate,
        isComponentValid,
        registerComponentValidation,
    } = useValidation('FNOLCAVehiclePage');
    const typeList = viewModelService.create(
        {},
        'cc',
        'edgev1141.capabilities.claim.lob.impl.commonauto.dto.VehicleIncidentDTO'
    );


    const lossPartyTypeList = vehicleUtils.getTypeList();

    useEffect(() => {
        const vehiclesPath = 'lobs.commercialAuto.vehicles.value';
        const selectedVehicles = _.get(claimVM, vehiclesPath, []);
        const vehicleIncidents = _.get(claimVM.value, 'lobs.commercialAuto.vehicleIncidents');
        if (selectedVehicles.length > 0) {
            if (vehicleIncidents && vehicleIncidents.length === 0) {
                selectedVehicles.push(newContact);
                updateIsVehicleChosen(false);
            } else {
                vehicleIncidents.forEach((vehicleIncident, index) => {
                    const isPresent = selectedVehicles.some((selectedVehicle) => {
                        return selectedVehicle.licensePlate == vehicleIncident.vehicle.licensePlate;
                    })
                    if (!isPresent) {
                        selectedVehicles.push(new Vehicle(vehicleIncident.vehicle));
                    }
                });
            }
            updateVehicleList(selectedVehicles);
        }
        if (vehicleIncidents && vehicleIncidents.length === 0) {
            // claimVM.lobs.commercialAuto.value.generateVehicleIncidents(selectedVehicles);
            addVehicleIncident();
            updateWizardData(claimVM);
            setLossPartyType('insured', 0);
        }
        ismotorClaim.current = ((claimVM.policy.policyNumber.value.slice(0, 2).toLowerCase() === 'bv' ||
            claimVM.policy.policyNumber.value.slice(0, 2).toLowerCase() === 'cx'));

        isApplicableForPolicySection_Ext.current = (claimVM.policy.policyType.value == 'P001' || claimVM.policy.policyType.value == 'comm_motor' || claimVM.policy.policyType.value == 'comm_motor_trade')
        setIsApplicableForPolicySection();
        const lossCauseCode = _.get(claimVM, 'lossCause.value');
        const collisionAndOtherCodes = LossCauseUtil.getCollisionCodes().concat(LossCauseUtil.getOtherCodes());
        //lino uncoment
        if (lossCauseCode !== undefined)
            isTheftOrGlassLossCause.current = collisionAndOtherCodes.indexOf(lossCauseCode.code) !== -1;
        setcaVehicleCounty();
        // Call once when page gets rendered
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const writeValue = useCallback(
        (value, path) => {
            const newClaimVM = _.clone(claimVM);
            _.set(newClaimVM, path, value);
            updateWizardData(newClaimVM);
        },
        [claimVM, updateWizardData]
    );

    const getAvailableDrivers = useCallback(
        (selectedContact, index, isInsured) => {
            // let driversItems = [];
            //if(isInsured){
            const driversItems = claimVM.lobs.commercialAuto.vehicleIncidents.value[
                index
            ].availableDrivers(claimVM.lobs.commercialAuto.value, selectedContact);
            // }
            driversItems.push(newContact);
            const driverValues = driversItems.map((driverValue) => {
                const val = driverValue.placeholder
                    ? translator(messages.caOtherDriver)
                    : driverValue.getDisplayName(translator(messages.caNewDriver));
                return {
                    code: val,
                    name: val
                };
            });
            // const driverValues = driversItems.reduce(function(filterArray, driverValue){

            //     if (driverValue && driverValue.placeholder) {
            //         const val = driverValue.placeholder
            //         ? translator(messages.caOtherDriver)
            //         : driverValue.getDisplayName(translator(messages.caNewDriver));
            //         filterArray.push({
            //             code: val,
            //             name: val
            //         });
            //         //$scope.vehicleIncident.driver.isMotorFleetDriver_Ext.value = $scope.isMotorFleetClaimExt();
            //         //$scope.vehicleIncident.driver.isPrivateCarDriver_Ext.value = $scope.isPrivateCarExt();
            //     }
            //     return filterArray
            // }, []);
            return driverValues;
        },
        [claimVM, newContact, translator]
    );

    const getDriverValue = useCallback(
        (index) => {
            const driverPath = `lobs.commercialAuto.vehicleIncidents.value[${index}].driver`;
            const selectedDriver = _.get(claimVM, driverPath);
            return !_.isEmpty(selectedDriver)
                ? selectedDriver.getDisplayName(translator(messages.caNewDriver))
                : '';
        },
        [claimVM, translator]
    );
    const getVehicleValue = useCallback(
        (index) => {
            const driverPath = `lobs.commercialAuto.vehicleIncidents.value[${index}].vehicle`;
            const selectedVehicle = _.get(claimVM, driverPath);
            return !_.isEmpty(selectedVehicle)
                ? selectedVehicle.getDisplayName(translator(messages.caNewDriver))
                : 'none';
        },
        [claimVM, translator]
    );

    const getAvailableYears = useCallback(() => {
        const currentYear = new Date().getFullYear();
        const years = [];
        for (let i = currentYear; i >= currentYear - oldestCarYear; i -= 1) {
            years.push({
                code: i,
                name: i
            });
        }
        return years;
    }, [oldestCarYear]);

    const removeEmptyDriver = useCallback((vehicleIncident) => {
        const availableDrivers = vehicleIncident.availableDrivers(claimVM.lobs.commercialAuto.value, null);
        const emptyDriver = availableDrivers.find(driver => !driver.firstName && !driver.lastName);
        if (emptyDriver) {
            vehicleIncident.removeDriver(claimVM.value, emptyDriver);
        }
    }, []);
    const handleVehicleSelect = useCallback(
        (value, selectedIndex) => {
            //const vehicleIncidentPath = `lobs.commercialAuto.vehicleIncidents.value[${selectedIndex}]`;
            //const vehicleIncident = _.get(claimVM, vehicleIncidentPath);
            let selectedVehicle = {};
            updateIsVehicleChosen(true);
            //removeEmptyDriver(vehicleIncident);
            if (value === translator(messages.caOtherVehicle)) {
                //vehicleIncident.setNewDriver(claimVM.value);
                const defaultCountryCode = localeService.getDefaultCountryCode();
                const newVehicle = claimVM.lobs.commercialAuto.value.createVehicle({
                    country: defaultCountryCode
                });
                _.set(claimVM, `lobs.commercialAuto.vehicleIncidents.value[${selectedIndex}].vehicle`, newVehicle);
                updateWizardData(claimVM);
            } else {
                selectedVehicle = vehicleList.find((vehicle) => {
                    if (vehicle.getDisplayName) {
                        const driverName = vehicle.getDisplayName(translator(messages.caNewDriver));
                        return driverName === value;
                    }
                    return false;
                });
                if (!_.isEmpty(selectedVehicle)) {
                    _.set(claimVM, `lobs.commercialAuto.vehicleIncidents.value[${selectedIndex}].vehicle`, selectedVehicle);
                    if (!_.get(claimVM, `lobs.commercialAuto.vehicleIncidents.value[${selectedIndex}].vehicleLossParty_Ext`))
                        _.set(claimVM, `lobs.commercialAuto.vehicleIncidents.value[${selectedIndex}].vehicleLossParty_Ext`, 'insured');
                } else {
                    _.set(claimVM, `lobs.commercialAuto.vehicleIncidents.value[${selectedIndex}].vehicle`, []);
                }
                updateWizardData(claimVM);
            }
        },
        [claimVM, translator, updateWizardData]
    );
    const handleDriverSelect = useCallback(
        (value, selectedIndex) => {
            const vehicleIncidentPath = `lobs.commercialAuto.vehicleIncidents.value[${selectedIndex}]`;
            const vehicleIncident = _.get(claimVM, vehicleIncidentPath);
            let selectedDriver = {};
            removeEmptyDriver(vehicleIncident);
            if (value === translator(messages.caOtherDriver)) {
                vehicleIncident.setNewDriver(claimVM.value);
                updateWizardData(claimVM);
            } else {
                const driversItems = _.get(claimVM, 'contacts.value', []);
                selectedDriver = driversItems.find((driver) => {
                    const driverName = driver.getDisplayName(translator(messages.caNewDriver));
                    return driverName === value;
                });
                if (!_.isEmpty(selectedDriver)) {
                    _.set(claimVM, `lobs.commercialAuto.vehicleIncidents.value[${selectedIndex}].driver`, selectedDriver);
                } else {
                    _.set(claimVM, `lobs.commercialAuto.vehicleIncidents.value[${selectedIndex}].driver`, null);
                }
                updateWizardData(claimVM);
            }
            if (vehicleIncident.driver) {
                debugger;
                vehicleIncident.driver.isMotorFleetDriver_Ext = ismotorClaim.current;
                vehicleIncident.driver.isPrivateCarDriver_Ext = vehicleIncident.isprivateCar();
            }
        },
        [claimVM, translator, updateWizardData]
    );

    const createTypeList = useCallback(() => {
        return typeList.collisionPoint.aspects.availableValues[0].typelist;
    }, [viewModelService]);

    const renderTriggerAddPerson = useCallback(
        (dropDownProps, toggleMenu) => {
            const { isOpen } = dropDownProps;
            const onAddPersonClick = () => {
                toggleMenu(!isOpen);
            };
            return (
                <Button onClick={onAddPersonClick} icon="mi-expand-more" iconPosition="right">
                    {translator(messages.caAddPassenger)}
                </Button>
            );
        },
        [translator]
    );

    const generatePassengerTableRow = useCallback(
        (evt, incidentIndex, index) => {
            evt.preventDefault();
            const getCurrentMenuItemID = evt.currentTarget.id;
            const getCurrentMenuItemIDNew = getCurrentMenuItemID.split('_');
            const contactsPath = 'contacts.value';
            const contactsItems = _.get(claimVM, contactsPath, []);
            if (getCurrentMenuItemIDNew[0].indexOf('anotherPersonLink') === -1) {
                const selectedPassenger = contactsItems[index];
                if (_.filter(contactsItems, selectedPassenger).length) {
                    claimVM.lobs.commercialAuto.vehicleIncidents.value[incidentIndex].addPassenger(
                        selectedPassenger,
                        claimVM.value
                    );
                }
            } else {
                claimVM.lobs.commercialAuto.vehicleIncidents.value[incidentIndex].addPassenger(
                    null,
                    claimVM.value
                );
            }
            updateWizardData(claimVM);
        },
        [claimVM, updateWizardData]
    );

    const handleVehicleIncidentDelete = useCallback(
        (event, vehicleIncident) => {
            event.stopPropagation();
            ModalNextProvider.showConfirm({
                title: messages.caDeleteVehicleTitle,
                message: messages.caDeleteVehicleMessage,
                status: 'warning',
                icon: 'mi-error-outline',
                confirmButtonText: messages.caResponseYes,
                cancelButtonText: messages.caResponseNo
            }).then(
                (results) => {
                    if (results === 'cancel') {
                        return _.noop();
                    }
                    claimVM.lobs.commercialAuto.value.removeVehicleIncident(vehicleIncident);
                    updateWizardData(claimVM);
                    return true;
                }, _.noop
            );
        },
        [claimVM, updateWizardData]
    );
    const searchOnCarWeb = useCallback((vehicle, index) => {
        return FNOLService.carWebLookup(vehicle.licensePlate, authHeader)
            .then((vehicleInfo) => {
                errorMessages.current[index] = errorMessages.current[0]
                errorMessages.current[index].carWebLookup = "";
                vehicleUtils.autofillVehicleinfo(vehicle, vehicleInfo);
                return true;
            })
            .catch(() => {
                errorMessages.current[index] = errorMessages.current[0];
                errorMessages.current[index].carWebLookup = "Carweb Lookup service unavailable, please enter the details manually.";
                vehicleUtils.setAvailableOnCarweblookup(vehicle);
            })
            .finally(() => {
                updateWizardData(claimVM);
            })
    }, [FNOLService, authHeader, claimVM, updateWizardData]);

    const renderAccordionHeader = useCallback(
        (isOpen, vehicleIncident, vehicleIncidents, index) => {
            const { vehicle } = vehicleIncident;
            const tabHeading = displayableVehicleProperties
                .filter((prop) => vehicle[prop])
                .map((prop) => vehicle[prop])
                .join(' ');
            const vehicleAccordionTitle = _.isEmpty(tabHeading)
                ? vehicleIncident.vehicle.getDisplayName(translator(messages.caNewVehicle))
                : tabHeading;
            return (
                <React.Fragment>
                    <Chevron isOpen={isOpen} align="right" className={caClaimStyles.chevronStyle} />
                    <h4 className="wizardTitle">
                        <Icon icon="mi-directions_car" />
                        {vehicleAccordionTitle}
                        {(vehicleIncidents.length > 1) ? (
                            <IconButton
                                icon="mi-delete"
                                value={vehicleIncident}
                                className={caClaimStyles.caVehicleIncidentDeleteIcon}
                                onClick={(event) => {
                                    handleVehicleIncidentDelete(event, vehicleIncident);
                                    removeErrorAtIndex(index);
                                }}
                            />
                        ) : null}
                    </h4>
                </React.Fragment>
            );
        },
        [handleVehicleIncidentDelete, translator]
    );

    const setLossPartyType = useCallback(
        (selectedLossPartyType, selectedIndex) => {
            const vehicleIncidentPath = `lobs.commercialAuto.vehicleIncidents.children[${selectedIndex}].vehicleLossParty_Ext`;
            _.set(claimVM, vehicleIncidentPath, selectedLossPartyType);
            const driverpath = `lobs.commercialAuto.vehicleIncidents.value[${selectedIndex}].driver`;
            const driver = _.get(claimVM, driverpath)
            if (selectedLossPartyType === 'insured' && driver == null) {
                _.set(claimVM, driverpath, {});
            } else if (selectedLossPartyType === 'third_party' && driver !== null && _.isEmpty(driver)) {
                _.set(claimVM, driverpath, null);
            }
            updateWizardData(claimVM);
        },
        [claimVM, updateWizardData]
    );
    const makeLicencePlateUppercase = useCallback(
        (licenceplate, selectedIndex) => {
            const licenceplateUpper = licenceplate.toUpperCase().replaceAll(/\s/g, '');
            const vehicleIncidentPath = `lobs.commercialAuto.vehicleIncidents.children[${selectedIndex}].vehicle.licensePlate`;
            _.set(claimVM, vehicleIncidentPath, licenceplateUpper);
            updateWizardData(claimVM);
        },
        [claimVM, updateWizardData]
    );
    const removeVehicleData = useCallback(
        (vehicleIncident, licenceplate) => {
            if (vehicleIncident !== 'undefined') {
                if (vehicleIncident.vehicle.licenceplate !== licenceplate.toUpperCase().replaceAll(/\s/g, '')) {
                    vehicleUtils.removeVehicleinfo(vehicleIncident.vehicle);
                }
                updateWizardData(claimVM);
            }
        },
        [claimVM, updateWizardData]
    );


    const setTrailerVehicle = useCallback(
        (vehicleIncident, selectedIndex, isInsured) => {
            if (vehicleIncident !== 'undefined') {
                if (selectedIndex !== 0 && isInsured) {
                    vehicleUtils.setTrailerVehicleInfo(vehicleIncident);
                } if (!isInsured) {
                    vehicleUtils.removeTrailerVehicleInfo(vehicleIncident);
                }
                updateWizardData(claimVM);
            }
        },
        [claimVM, updateWizardData]
    );

    const setcaVehicleStatusDropdownList = useCallback((selectedIndex) => {
        if (vehicleStatusDropdownList.current === null) {
            const vehicleStatusList = _.get(claimVM, `lobs.commercialAuto.vehicleIncidents.children[${selectedIndex}].vehicleStatus_Ext.aspects.availableValues`);
            vehicleStatusDropdownList.current = vehicleStatusList.reduce(function (filtered, option) {
                const someNewValue = {
                    code: option.code,
                    name: translator({
                        id: option.name,
                        defaultMessage: option.name
                    })
                }
                if (vehicleUtils.availableVehicleStatuses.indexOf(option.code) !== -1) {
                    filtered.push(someNewValue);
                }
                return filtered;
            }, []);
        }
        return vehicleStatusDropdownList.current;
    }, [claimVM]);

    const getPolicySectionValues = () => {
        if (isApplicableForPolicySection_Ext.current
            && claimVM.policy.policySections_Ext.value) {
            return claimVM.policy.policySections_Ext.value.map((sec) => {
                let displayDescription = sec.sectionDescription;
                if (sec.dateAdded) {
                    const date = sec.dateAdded.split('T', 1)[0];
                    displayDescription = `${sec.sectionDescription} : On ${date}`;
                }
                return {
                    code: sec.publicID,
                    name: displayDescription
                };
            });
        }
        return [];
    };

    const onPolicySectionChange = useCallback((value) => {
        const selectedPolSection = _.filter(
            claimVM.policy.policySections_Ext.value,
            (section) => {
                return section.publicID === value;
            }
        );
        _.set(claimVM, 'policySectionCode_Ext.value', selectedPolSection[0]);
        updateWizardData(claimVM);
    },
        [claimVM, updateWizardData]);

    const getyesNoTbcOptions = useCallback((selectedIndex) => {
        if (yesNoTbcOptions.current === null) {
            let otherConvictionAvailableValues = viewModelService
                .productMetadata
                .get('cc')
                .types
                .getTypelist('YesNoTbc').codes;
            yesNoTbcOptions.current = otherConvictionAvailableValues.map((option) => {
                let defaultMessageval = option.name;
                if (option.code === 'TBC') {
                    defaultMessageval = 'Not Known';
                    return {
                        code: option.code,
                        name: defaultMessageval
                    };
                }
                return {
                    code: option.code,
                    name: translator({
                        id: option.name,
                        defaultMessage: defaultMessageval
                    })
                };
            });
        }
        return yesNoTbcOptions.current;
    }, [claimVM]);

    const getVehicleList = useCallback(() => {
        const allVehicle = vehicleList.map((vehicle) => {
            const val = vehicle.placeholder
                ? translator(messages.caOtherVehicle)
                : vehicle.getDisplayName(translator(messages.caNewDriver));
            return {
                code: val,
                name: val
            };
        });
        return allVehicle;
    }, [claimVM, vehicleList]);

    const setVehicleUseDropdownList = useCallback((selectedIndex) => {
        if (vehicleUseDropdownList.current === null) {
            const vehicleUseList = _.get(claimVM, `lobs.commercialAuto.vehicleIncidents.children[${selectedIndex}].vehicleUse_Ext.aspects.availableValues`);
            vehicleUseDropdownList.current = vehicleUseList.reduce((filtered, option) => {
                const typeCodes = [];
                const someNewValue = {
                    code: option.code,
                    name: translator({
                        id: option.name,
                        defaultMessage: option.name
                    })
                };
                if (!claimVM.isRefreshFleetRequired.value) {
                    typeCodes.push('Volunteering');
                    filtered = [{
                        code: 'Volunteering',
                        name: translator({
                            id: 'Volunteering',
                            defaultMessage: 'Volunteering'
                        })
                    }];
                }
                if (typeCodes.indexOf(option.code) === -1) {
                    filtered.push(someNewValue);
                }
                return filtered;
            }, []);
        }
        return vehicleUseDropdownList.current;

    }, [claimVM]);

    const onVatRegisterChange = useCallback(
        (vatRegisterValue, selectedIndex) => {
            const path = `lobs.commercialAuto.vehicleIncidents.children[${selectedIndex}]`;
            _.set(claimVM, `${path}.vatIncluded_Ext.value`, vatRegisterValue);
            if (!vatRegisterValue) {
                _.set(claimVM, `${path}.vatStatusIndicator_Ext.value`, null);
                _.set(claimVM, `${path}.vatRate_Ext.value`, null);
            } else {
                _.set(claimVM, `${path}.vatStatusIndicator_Ext.value`, 'UK');
            }
            updateWizardData(claimVM);
        },
        [claimVM, updateWizardData]
    );

    const fillDefaultDVLA_Ext = useCallback(
        (selectedIndex) => {
            const path = `lobs.commercialAuto.vehicleIncidents.children[${selectedIndex}]`;
            const hasMedCondition = _.get(claimVM, `${path}.hasMedicalConditionsDVLAtoBeNotifiedInd_Ext.value`);
            if (hasMedCondition === undefined || hasMedCondition === 'null') {
                _.set(claimVM, `${path}.hasMedicalConditionsDVLAtoBeNotifiedInd_Ext.value`, 'TBC');
                updateWizardData(claimVM);
            }
        },
        [claimVM, updateWizardData]
    );
    const setHasOtherConviction = useCallback(
        (selectedOtherConvictionRadio, selectedIndex) => {

            const vehicleIncidentPath = `lobs.commercialAuto.vehicleIncidents.children[${selectedIndex}].driver.hasOtherConvictions_Ext`;
            const previousConvictionsPath = `lobs.commercialAuto.vehicleIncidents.value[${selectedIndex}].driver.previousConvictions`;

            _.set(claimVM, vehicleIncidentPath, selectedOtherConvictionRadio);
            if (selectedOtherConvictionRadio === 'Yes' && ismotorClaim.current) {
                addNewConvictionRow(selectedIndex);
            } else {
                if (ismotorClaim.current) {
                    _.set(claimVM, previousConvictionsPath, []);
                }
                updateWizardData(claimVM);
            }
        },
        [claimVM, updateWizardData]
    );
    const setDepotCode = useCallback(
        (selectedDepot, selectedIndex) => {
            const vehicleIncidentPath = `lobs.commercialAuto.vehicleIncidents.value[${selectedIndex}].fleetDepot_Ext`;
            const depolist = _.get(claimVM.value, 'specialHandlingDepots_Ext');
            const selectedDepotContact = depolist.find((depo) => {
                return depo.depotContact.depotCode === selectedDepot;
            });
            const fleetDepot = {
                publicID: selectedDepot,
                depotContact: selectedDepotContact
            };
            _.set(claimVM, vehicleIncidentPath, selectedDepotContact);
            updateWizardData(claimVM);
        },
        [claimVM, updateWizardData]
    );

    const addNewConvictionRow = useCallback((selectedIndex) => {
        const path = `lobs.commercialAuto.vehicleIncidents.value[${selectedIndex}].driver.previousConvictions`;
        const emptyConviction = {
            convictionDate_Ext: null,
            convictionCode_Ext: null,
            points: null,
            convictionHeldOnCoronet: false,
            select: false
        };
        const convictionRow = _.get(claimVM, path)
        if (typeof convictionRow === "undefined") {
            _.set(claimVM, path, [emptyConviction]);
            updateWizardData(claimVM);
        } else {
            convictionRow.push(emptyConviction);;
            updateWizardData(claimVM);
        }

    }, [claimVM, updateWizardData]);

    const deleteConvictionRow = useCallback(
        (selectedIndex) => {
            const path = `lobs.commercialAuto.vehicleIncidents.value[${selectedIndex}].driver.previousConvictions`;
            _.set(claimVM, path, _.get(claimVM, path).filter(obj => !obj.select));
            updateWizardData(claimVM);
        },
        [claimVM, updateWizardData]
    );
    //Address row
    const setcaVehicleCounty = useCallback((selectedIndex) => {
        if (county.current === null) {
            const vehicleCountyList = viewModelService
                .productMetadata
                .get('cc')
                .types
                .getTypelist('County').codes;
            county.current = vehicleCountyList.reduce(function (filtered, option) {
                const someNewValue = {
                    code: option.code,
                    name: translator({
                        id: option.name,
                        defaultMessage: option.name
                    })
                }
                if (!option.isRetired_Ext) {
                    filtered.push(someNewValue);
                }
                return filtered;
            }, []);
        }
        return county.current;
    }, [claimVM]);

    const getPreferredAddressDropDownValues = useCallback(
        () => {
            let addressData = [];
            if (claimVM && claimVM.value.predefinedLossLocations) {
                addressData = claimVM.value.predefinedLossLocations;
            }
            if (claimVM.value.lossLocation.addressLine1
                && !_.includes(addressData, claimVM.value.lossLocation)) {
                addressData.push(claimVM.value.lossLocation);
            }
            if (addressData) {
                return addressData.map((address, index) => {
                    const addressJoin = [
                        address.addressLine1,
                        address.addressLine2,
                        address.addressLine3,
                        address.city,
                        address.postalCode
                    ];

                    const addressArrayJoin = _.values(addressJoin)
                        .filter((value) => !!value)
                        .join(', ');
                    const addressArrayJoinKey = {
                        code: _.toString(index),
                        name: addressArrayJoin
                    };
                    return addressArrayJoinKey;
                });
            }
            return [];
        }, [claimVM]
    );

    const getSelectedLocationValue = useCallback(
        (index) => {
            // const driverPath = `lobs.commercialAuto.vehicleIncidents.value[${index}].vehicleLocation_Ext`;
            // const selectedLocation = _.get(claimVM, driverPath);
            return selectedAddressList.length >= index ? selectedAddressList[index] : '';
        },
        [claimVM, translator]
    );

    const handlePostCodeAddressDropDownValueChange = useCallback(async (locationIndex, addressIndex) => {
        updateshowPostCodeLoader(true);
        const currentLocation = _.get(
            claimVM,
            `lobs.commercialAuto.vehicleIncidents.children[${locationIndex}].vehicleLocation_Ext`
        )
        const updatedLocations = lookupResult_Ext.resultSummaries.find((location) => {
            return location.addressSummary === addressIndex;
        });
        const newAddress = new Address();
        newAddress.postalCode = currentLocation.postalCode.value;
        if (updatedLocations) {
            await AddressLookupService.getAddressFromLookup(updatedLocations, newAddress, authHeader)
                .then((lookupResult) => {
                    _.set(claimVM, `lobs.commercialAuto.vehicleIncidents.children[${locationIndex}].vehicleLocation_Ext`, lookupResult);
                    updateWizardData(claimVM);
                    updateshowPostCodeLoader(false);
                    //updateShowLookupResult_Ext(false);
                }).catch(() => {
                    updateshowPostCodeLoader(false);
                    ModalNextProvider.showAlert({
                        title: messages.postCodeLookupErrorTitle,
                        message: translator(messages.postCodeLookupErrorMessage),
                        status: 'error',
                        icon: 'mi-error-outline',
                        confirmButtonText: messages.postCodeLookupErrorConfirmMessage
                    }).catch(_.noop);
                });
        } else {
            updateshowPostCodeLoader(false);
            _.set(claimVM, `lobs.commercialAuto.vehicleIncidents.children[${locationIndex}].vehicleLocation_Ext`, newAddress);
        }
    },
        [claimVM, authHeader, updateWizardData, AddressLookupService, translator, lookupResult_Ext]);

    const getMultipleLookupResult = useCallback(() => {
        const locationCodes = lookupResult_Ext && lookupResult_Ext.resultSummaries;
        if (locationCodes) {
            return locationCodes.map((locationCode) => {
                return {
                    code: locationCode.addressSummary,
                    name: locationCode.addressSummary
                };
            });
        }
        return [];
    }, [lookupResult_Ext]);

    const lookupClick = useCallback(async (selectedIndex) => {
        const newAddress = new Address();
        const path = `lobs.commercialAuto.vehicleIncidents.value[${selectedIndex}].vehicleLocation_Ext`;
        newAddress.postalCode = _.get(claimVM, `${path}.postalCode`);
        await AddressLookupService.addressLookup(newAddress, authHeader)
            .then((lookupResult) => {
                // TODO Handle for multiple addresses
                /* if (!lookupResult.fetchRequired) {
                    _.set(claimVM, path, lookupResult.address);
                } */
                if (lookupResult.fetchRequired) {
                    updatelookupResult_Ext(lookupResult);
                    updateShowLookupResult_Ext(true);
                } else {
                    updateShowLookupResult_Ext(false);
                    _.set(claimVM, path, lookupResult.address);
                }

                updateWizardData(claimVM);
            }).catch(() => {
                ModalNextProvider.showAlert({
                    title: messages.postCodeLookupErrorTitle,
                    message: translator(messages.postCodeLookupErrorMessage),
                    status: 'error',
                    icon: 'mi-error-outline',
                    confirmButtonText: messages.postCodeLookupErrorConfirmMessage
                }).catch(_.noop);
            });
    }, [authHeader, updateWizardData, AddressLookupService, translator]);

    const handleAddressDropDownValueChange = useCallback(
        (addressIndex, selectedIndex) => {
            const updatedLocations = claimVM.predefinedLossLocations.value.find((loss, index) => {
                return index === parseInt(addressIndex, 10);
            });
            const path = `lobs.commercialAuto.vehicleIncidents.value[${selectedIndex}].vehicleLocation_Ext`;
            //_.set(claimVM.value, 'optionalLossLocation.predefinedAddress', updatedLocations);
            const newLocation = _.omit(updatedLocations, 'publicID');
            const listValue = selectedAddressList;
            listValue[selectedIndex] = { code: _.toString(addressIndex), name: updatedLocations.displayName };
            updateSelectedAddressList(listValue);
            _.set(claimVM, path, newLocation);
            updateWizardData(claimVM);
        },
        [claimVM, updateWizardData]
    );
    const handleVehicleTypeChange = useCallback(
        (categoryValue, selectedIndex) => {

            const path = `lobs.commercialAuto.vehicleIncidents.value[${selectedIndex}]`;
            //_.set(claimVM.value, 'optionalLossLocation.predefinedAddress', updatedLocations);
            _.set(claimVM, `${path}.category_Ext`, categoryValue);
            _.set(claimVM, `${path}.damagePoints_Ext`, []);
            updateWizardData(claimVM);
        },
        [claimVM, updateWizardData]
    );
    const checkIfTowingTrailerSelected = function (vehicleIncidents) {
        return vehicleIncidents.some((vehicleIncident) => {
            return vehicleIncident.vehicleLossParty_Ext === 'insured' && vehicleIncident.towingTrailerInd_Ext;
        });
    }
    const checkIfTrailerAdded = function (vehicleIncidents) {
        return vehicleIncidents.some((vehicleIncident) => {
            return (vehicleIncident.vehicleLossParty_Ext === 'insured' && vehicleIncident.vehicle !== null && vehicleIncident.vehicle.licensePlate === 'TRAILER');
        });
    }
    const checkIfInsuredSelected = function (vehicleIncidents) {
        return vehicleIncidents.some((vehicleIncident) => {
            return vehicleIncident.vehicleLossParty_Ext === 'insured';
        })
    }
    const checkIfInsuredSelectedWithCondition = function (vehicleIncidents, currentIndex) {
        return vehicleIncidents.some((vehicleIncident, index) => {
            return vehicleIncident.vehicleLossParty_Ext === 'insured' && index !== currentIndex;
        })
    }
    const showTowingTrailerValidation_Ext = function (vehicleIncidents) {
        const insuredVehicleIncidents_Ext = vehicleIncidents.filter(vehicleIncident => {
            return vehicleIncident.vehicleLossParty_Ext
                && vehicleIncident.vehicleLossParty_Ext === 'insured';
        })
        if (insuredVehicleIncidents_Ext.length > 1) {
            return false;
        } else {
            const towingNotificationNeeded = vehicleIncidents.some((vehicleIncident) => {
                return vehicleIncident.towingTrailerInd_Ext
            });
            if (towingNotificationNeeded) {
                ModalNextProvider.showAlert({
                    //title: messages.ownRepairSubmitErrorTitle,
                    message: 'To add a trailer, please select Add Another Vehicle or Trailer at the bottom of this page',
                    status: 'info',
                    icon: 'mi-info-outline',
                    confirmButtonText: 'Ok'
                }).catch(_.noop);
            }
        }
    }

    const isPostCodeValidArc = (addressVM) => {
        if (addressVM && addressVM.postalCode) {
            const isValid = addressVM.postalCode.aspects.valid && addressVM.postalCode.aspects.subtreeValid;
            return !isValid;
        }
        return true;
    };

    const isPostCodeValid = (addressVM) => {
        if (addressVM && addressVM.value && addressVM.value.postalCode) {
            // eslint-disable-next-line max-len
            const postCodeRegex = /^(([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9]?[A-Za-z])))) [0-9][A-Za-z]{2}))$/;
            return !postCodeRegex.test(addressVM.value.postalCode);
        }
        return true;
    };

    const isUnitedKingdomChosen = (addressVM) => {
        if (addressVM && addressVM.value && addressVM.value.country && addressVM.value.country) {
            return addressVM.value.country === 'GB';
        }
        return false;
    };

    const onDriverDobChange = useCallback((value, selectedIndex) => {
        const path = `lobs.commercialAuto.vehicleIncidents.value[${selectedIndex}].driver`;
        //const dobVlaue = _.get(claimVM, `${path}.dateOfBirth`);
        const birthDate = new Date(value);
        if (birthDate instanceof Date && !isNaN(birthDate)) {
            _.set(claimVM, `${path}.age_Ext`, DateUtil.calculateAgeInYearsExt(new Date(), birthDate));
        }
        _.set(claimVM, `${path}.dateOfBirth`, value);
        updateWizardData(claimVM);
    }, [claimVM, updateWizardData]);

    const isdamageSelection = (vehicleIncident) => {
        const isVisibleForVehicleType = vehicleIncident.getVehicleType(vehicleIncident.category_Ext) !== 'N';
        const lossCauseCode = _.get(claimVM.value, 'lossCause');
        const vehicleStolen = LossCauseUtil.LossCauseDescToCodeMap.TheftOfVeh === lossCauseCode;
        const isGlass = LossCauseUtil.LossCauseDescToCodeMap.WindscrOnly === lossCauseCode;
        const vehicleRecovered = _.get(claimVM.value, 'isVehicleRecovered_Ext');
        const isVisibleForLossCauseAndRecovery = !vehicleStolen || vehicleRecovered;
        return isVisibleForVehicleType && isVisibleForLossCauseAndRecovery && !isGlass;
    };
    const getAvailableDepots = useCallback((vehicleIncident) => {
        const depolist = _.get(claimVM.value, "specialHandlingDepots_Ext");
        if (depolist) {
            return depolist.map((depot) => {
                return {
                    code: depot.depotContact.depotCode,
                    name: depot.depotContact.name
                };
            });
        }
        return [];
    }, []);
    const generateVehicleOverrides = useCallback(() => {
        const vehicleIncidentsPath = 'lobs.commercialAuto.vehicleIncidents.value';
        const vehicleIncidents = _.get(claimVM, vehicleIncidentsPath, []);
        const overrides = vehicleIncidents.map((vehicleIncident, index) => {
            if (_.isNull(vehicleIncident.vehicle)) {
                const isVehicleDropdown = vehicleList && vehicleList.length > 0 && !checkIfInsuredSelectedWithCondition(vehicleIncidents, index);
                const defaultCountryCode = localeService.getDefaultCountryCode();
                const newVehicle = claimVM.lobs.commercialAuto.value.createVehicle({
                    country: defaultCountryCode
                });
                if (!isVehicleDropdown) {
                    _.set(vehicleIncident, 'vehicle', newVehicle);
                } else {
                    _.set(vehicleIncident, 'vehicle', Object.create(newVehicle));
                }
                if (index > 0 && ((checkIfTowingTrailerSelected(vehicleIncidents) && checkIfTrailerAdded(vehicleIncidents)) || !checkIfTowingTrailerSelected(vehicleIncidents))) {
                    _.set(vehicleIncident, 'vehicleLossParty_Ext', 'third_party');
                }
                if (index > 0 && checkIfTowingTrailerSelected(vehicleIncidents) && !checkIfTrailerAdded(vehicleIncidents)) {
                    _.set(vehicleIncident, 'vehicleLossParty_Ext', 'insured');
                    vehicleUtils.setTrailerVehicleInfo(vehicleIncident);
                }
                updateWizardData(claimVM);
                renderAccordionHeader(false, vehicleIncident, vehicleIncidents);
            }
            const currentLossParty = _.get(
                claimVM,
                `lobs.commercialAuto.vehicleIncidents.children[${index}].vehicleLossParty_Ext.value.code`
            );
            const currentConvictionRadio = _.get(
                claimVM,
                `lobs.commercialAuto.vehicleIncidents.children[${index}].driver.hasOtherConvictions_Ext.value.code`
            );
            const currentDvlaRadio = _.get(
                claimVM,
                `lobs.commercialAuto.vehicleIncidents.children[${index}].driver.hasMedicalConditionsDVLAtoBeNotifiedInd_Ext.value.code`
            );
            const isInsured = ('insured' === currentLossParty);
            const categoryValue = _.get(
                claimVM,
                `lobs.commercialAuto.vehicleIncidents.children[${index}].category_Ext.value.code`
            );
            const isPrivcar = (categoryValue !== undefined && 'priv_car' === categoryValue);
            const previousConvictions = _.get(
                claimVM,
                `lobs.commercialAuto.vehicleIncidents.children[${index}].driver.previousConvictions.value`
            );
            const fullUkLicence = _.get(
                claimVM,
                `lobs.commercialAuto.vehicleIncidents.children[${index}].driver.fullUKLicense_Ext.value`
            );
            //const towingNotification = showTowingTrailerValidation_Ext(vehicleIncidents);
            const isdamageSelectionVisible = isdamageSelection(vehicleIncident);
            const isVehicleDropdown = vehicleList && vehicleList.length > 0 && !checkIfInsuredSelectedWithCondition(vehicleIncidents, index);
            const isVehicleDetails = !isVehicleDropdown || (isVehicleDropdown && getVehicleValue(index) !== "none");
            const isNotTrailerVehicle = (index === 0 || !isInsured);
            const isCurrentVehNotTrailer = vehicleIncident.vehicle.licensePlate !== 'TRAILER';
            const caLossPartyDisable = index === 0 ||
                (index > 0 && (checkIfTowingTrailerSelected(vehicleIncidents)) && checkIfTrailerAdded(vehicleIncidents)) && isCurrentVehNotTrailer ||
                (index > 0 && !(checkIfTowingTrailerSelected(vehicleIncidents)));

            const caVehRepAllowed = (claimVM.blameCode_Ext.value.code === 'TPI' || claimVM.blameCode_Ext.value.code === 'BOT') && index === 0
            && !LossCauseUtil.getVehRep_ExcludeLossCause().includes(claimVM.lossCause.value.code);

            return {
                [`caVehicleAccordionDetails${index}`]: {
                    renderHeader: (isOpen) => {
                        return renderAccordionHeader(isOpen, vehicleIncident, vehicleIncidents);
                    }
                },
                [`caChoseVehicle${index}`]: {
                    visible: isVehicleDropdown,
                    availableValues: getVehicleList(),
                    onValueChange: (value) => {
                        handleVehicleSelect(value, index);
                    },
                    value: getVehicleValue(index),
                },
                [`caVehicleOtherVehicleTitle${index}`]: {
                    visible: isVehicleDetails && !vehicleIncident.vehicle.policyVehicle
                },

                [`caMoreVehicleDetailsSection${index}`]: {
                    visible: isVehicleDetails
                },
                [`caOtherVehicleSectionCont${index}`]: {
                    visible: isVehicleDetails
                },
                [`caPointOfImpactSelect${index}`]: {
                    collisionPoints: [],
                    onValueChange: writeValue,
                    value: _.get(
                        claimVM,
                        `lobs.commercialAuto.vehicleIncidents.value[${index}].damagePoints_Ext`
                    ),
                    categoryValue: categoryValue
                },
                [`caPointOfImpactContainer${index}`]: {
                    visible: isdamageSelectionVisible
                },
                [`caPointOfImpact${index}`]: {
                    visible: isdamageSelectionVisible
                },

                [`caLossParty${index}`]: {
                    availableValues: vehicleUtils.getTypeList(index),
                    //disabled: (!vehicleIncident.vehicle.policyVehicle && vehicleIncident.isMultipleInsuredNotApplicable()),
                    onValueChange: (value) => {
                        setLossPartyType(value, index);
                        setTrailerVehicle(vehicleIncident, index, 'insured' === value);
                    },
                    value: currentLossParty,
                    disabled: caLossPartyDisable
                },
                [`caVehicleOtherVehiclePlate${index}`]: {
                    onValueChange: (value) => {
                        makeLicencePlateUppercase(value, index);
                        removeVehicleData(vehicleIncident, value);
                    },
                    disabled: !isNotTrailerVehicle,
                    readOnly: !isNotTrailerVehicle,
                    visible: isNotTrailerVehicle
                },
                [`carWebLookup${index}`]: {
                    visible: isNotTrailerVehicle,
                    disabled: (!vehicleIncident.vehicle.licensePlate || !vehicleIncident.vehicle.licensePlate.length),
                    onTrigger: async (e) => {
                        await searchOnCarWeb(vehicleIncident.vehicle, index, isNotTrailerVehicle);
                    }
                },
                [`carWebErrorMessage${index}`]: {
                    content: errorMessages.current[index] ? errorMessages.current[index].carWebLookup : null,
                    visible: isNotTrailerVehicle && !vehicleIncident.vehicle.vin && errorMessages.current[index] && errorMessages.current[index].carWebLookup !== '',
                },
                [`caVehicleOtherVehicleMake${index}`]: {
                    readOnly: isNotTrailerVehicle && (vehicleIncident.vehicle.vin)
                },
                [`caVehicleOtherVehicleModel${index}`]: {
                    readOnly: isNotTrailerVehicle && (vehicleIncident.vehicle.vin)
                },
                [`caVehicleUse${index}`]: {
                    visible: index === 0,
                    availableValues: setVehicleUseDropdownList(index)
                },
                [`caVehicleStatus${index}`]: {
                    visible: isNotTrailerVehicle,
                    availableValues: setcaVehicleStatusDropdownList(index)
                },
                [`caVehicleReplacement${index}`]: {
                    visible: caVehRepAllowed
                },
                [`caVehicleReplacementMessage${index}`]: {
                   visible: caVehRepAllowed
                },
                [`caOtherDriverMobilePhone${index}`]:{
                   required: vehicleIncident.vehicleReplacement_Ext,
                   showRequired: vehicleIncident.vehicleReplacement_Ext
                },
                [`caAdditionalDamageDescriptionAsterik${index}`]:{
                    visible: vehicleIncident.vehicleReplacement_Ext !== undefined && vehicleIncident.vehicleReplacement_Ext 
                },
                [`caDamageDescriptionText${index}`]: {
                    required: vehicleIncident.vehicleReplacement_Ext,
                    showRequired: vehicleIncident.vehicleReplacement_Ext,
                },
                [`caVehicleType${index}`]: {
                    onValueChange: (value, path) => {
                        handleVehicleTypeChange(value, index);
                    },
                    readOnly: !(isNotTrailerVehicle),
                    visible: isNotTrailerVehicle
                },
                [`caVehicleOtherVehicleColor${index}`]: {
                    visible: isNotTrailerVehicle,
                    readOnly: (vehicleIncident.vehicle.vin)
                },
                [`caVehicleWasVehicleTowed${index}`]: {
                    visible: isNotTrailerVehicle,
                    onValueChange: (value, path) => {
                        writeValue(value, path);
                        showTowingTrailerValidation_Ext(vehicleIncidents);
                    }
                },
                [`caVATregistered${index}`]: {
                    visible: index === 0,
                    onValueChange: (value) => {
                        onVatRegisterChange(value, index);
                    }
                },
                [`caVatRate${index}`]: {
                    visible: index === 0 && true === _.get(
                        claimVM,
                        `lobs.commercialAuto.vehicleIncidents.children[${index}].vatIncluded_Ext.value`
                    ),
                },
                [`caPolicySectionCodeExt${index}`]: {
                    visible: index === 0 && isApplicableForPolicySection_Ext.current && getPolicySectionValues().length > 0,
                    availableValues: getPolicySectionValues(),
                    onValueChange: (value) => {
                        onPolicySectionChange(value);
                    }
                    //value: _.get(claimVM, 'policySectionCode_Ext.value')
                },
                [`caVehiclesWhoDriving${index}`]: {
                    availableValues: getAvailableDrivers(vehicleIncident.driver, index, isInsured),
                    value: getDriverValue(index),
                    onValueChange: (value) => {
                        handleDriverSelect(value, index);
                    },
                    required: isInsured,
                    showRequired: isInsured,
                    visible: isNotTrailerVehicle
                    //visible: !(isInsured && checkIfInsuredSelectedWithCondition(vehicleIncidents,index))
                },
                [`caOtherDriverSection${index}`]: {
                    visible: isNotTrailerVehicle &&
                        !_.isEmpty(
                            _.get(
                                claimVM,
                                `lobs.commercialAuto.vehicleIncidents.children[${index}].driver.value`
                            )
                        )
                    //&& !(isInsured && checkIfInsuredSelectedWithCondition(vehicleIncidents,index))
                },
                [`caDriverDOB${index}`]: {
                    maxDate: new Date(),
                    onValueChange: (value, event) => {
                        onDriverDobChange(value, index);
                    },
                    visible: isNotTrailerVehicle
                },
                [`caDriverAgeDetails${index}`]: {
                    visible: index === 0
                },
                [`caAgeGroup${index}`]: {
                    visible: isNotTrailerVehicle && vehicleUtils.checkIsEmptyValue(
                        _.get(
                            claimVM,
                            `lobs.commercialAuto.vehicleIncidents.children[${index}].driver.age_Ext.value`
                        )
                    )
                },
                [`caDriverPrefix${index}`]: {
                    required: isInsured,
                    showRequired: isInsured,
                    visible: isNotTrailerVehicle
                },
                [`caOtherDriverFirstName${index}`]: {
                    required: isInsured,
                    showRequired: isInsured,
                    visible: isNotTrailerVehicle
                },
                [`caOtherDriverLastName${index}`]: {
                    required: isInsured,
                    showRequired: isInsured,
                    visible: isNotTrailerVehicle
                },
                [`caDriverConvictionButton${index}`]: {
                    visible: index === 0
                },
                [`caYesNoTbc${index}`]: {
                    visible: index === 0,
                    availableValues: getyesNoTbcOptions(index),
                    label: ismotorClaim.current ? {
                        "id": "fnol.ca.directives.add-new-vehicle.Does the driver have any motor convictions?",
                        "defaultMessage": "Does the driver have any of the convictions listed or minor convictions amounting to 10 points or more?"
                    } : {
                        "id": "fnol.ca.directives.add-new-vehicle.Does the driver have any motor convictions motorclaim?",
                        "defaultMessage": "Does the driver have any motor convictions?"
                    },
                    onValueChange: (value) => {
                        setHasOtherConviction(value, index);
                    },
                    value: currentConvictionRadio

                },
                [`convictionTable${index}`]: {
                    renderTitleAction: () => (
                        <div className={caClaimStyles.applyInlineFlex}>
                            <Button icon="mi-add" size="small" className={caClaimStyles.convictionBttn} onClick={() => addNewConvictionRow(index)}>Add</Button>
                            <Button icon="mi-remove" size="small" onClick={() => deleteConvictionRow(index)}>Remove</Button>
                        </div>
                    ),
                    data: previousConvictions ? previousConvictions : [],
                    visible: index === 0 && ismotorClaim.current && ("Yes" === _.get(
                        claimVM,
                        `lobs.commercialAuto.vehicleIncidents.children[${index}].driver.hasOtherConvictions_Ext.value.code`
                    ))
                },
                [`convictionPointTable${index}`]: {
                    visible: index === 0 && ismotorClaim.current && ("Yes" === _.get(
                        claimVM,
                        `lobs.commercialAuto.vehicleIncidents.children[${index}].driver.hasOtherConvictions_Ext.value.code`
                    ))
                },
                [`convictionCheckbox${index}`]: {
                    renderHeader: index === 0 && getSelectAllCheckBox(index)
                },
                [`caFullUkLicence${index}`]: {
                    visible: index === 0 && ismotorClaim.current && isPrivcar
                },
                [`caLicenceType${index}`]: {
                    visible: ((index === 0 && ismotorClaim.current && (fullUkLicence !== undefined && false === fullUkLicence || (categoryValue !== undefined && !isPrivcar)))
                        ||
                        (index === 0 && !ismotorClaim.current))
                },
                [`caLicenceHeldTime${index}`]: {
                    visible: index === 0 && !ismotorClaim.current
                },
                [`caLicenseheldOneYear${index}`]: {
                    visible: index === 0 && ismotorClaim.current
                },
                [`caYesNoTbcDVLAtoBeNotified${index}`]: {
                    visible: index === 0 && !ismotorClaim.current,
                    availableValues: getyesNoTbcOptions(index),
                    // onValueChange: (value) => {
                    //     setHasOtherConviction(value, index);
                    // },
                    value: currentDvlaRadio,
                    defaultValue: 'TBC'
                },
                [`caDriverDVLANotifiedDiv${index}`]: {
                    visible: ('Yes' === currentDvlaRadio)
                },
                [`caInjuryDescription${index}`]: {
                    visible: isNotTrailerVehicle && true === _.get(
                        claimVM,
                        `lobs.commercialAuto.vehicleIncidents.children[${index}].driver.injured_Ext.value`
                    )
                },
                [`caFleetDepot${index}`]: {
                    visible: index === 0 && vehicleIncident.depotsAvailable_Ext && vehicleIncident.hasDepots_Ext,
                    availableValues: getAvailableDepots(vehicleIncident),
                    value: _.get(
                        claimVM,
                        `lobs.commercialAuto.vehicleIncidents.value[${index}].fleetDepot_Ext.depotContact`
                    ) ? _.get(
                        claimVM,
                        `lobs.commercialAuto.vehicleIncidents.value[${index}].fleetDepot_Ext.depotContact`
                    ).depotCode : '',
                    onValueChange: (value) => {
                        setDepotCode(value, index);
                    },
                },
                [`caEmployeeDepot${index}`]: {
                    visible: index === 0 && vehicleIncident.depotsAvailable_Ext && !vehicleIncident.hasDepots_Ext
                },
                [`caSafeToDrive${index}`]: {
                    visible: isInsured && isTheftOrGlassLossCause.current
                },
                [`caAirbagsDeployed${index}`]: {
                    visible: index === 0 && isTheftOrGlassLossCause.current
                },
                [`caEquipmentFailure${index}`]: {
                    visible: isInsured && isTheftOrGlassLossCause.current
                },
                [`caPassengerContainer${index}`]: {
                    //lino uncomment on release
                    visible: isTheftOrGlassLossCause.current && isNotTrailerVehicle
                },
                [`caAddPassengerTable${index}`]: {
                    data: vehicleIncident.passengers,
                    visible: !_.isEmpty(vehicleIncident.passengers)
                },
                [`caPassengersAddPassenger${index}`]: {
                    renderTrigger: renderTriggerAddPerson
                },
                [`caVehicleOtherVehicleYear${index}`]: {
                    availableValues: getAvailableYears(),
                    value: _.get(
                        claimVM,
                        `lobs.commercialAuto.vehicleIncidents.children[${index}].vehicle.year.value`
                    ),
                    readOnly: isNotTrailerVehicle && (vehicleIncident.vehicle.vin)
                },
                [`addPersonDropDownItems${index}`]: {
                    data: claimVM,
                    incidentIndex: index,
                    updateAddPassengers: updateWizardData
                },
                [`anotherPersonLink${index}`]: {
                    onClick: (e) => {
                        generatePassengerTableRow(e, index);
                    }
                },
                [`caVehicleAddressLine1${index}`]: {
                    required: isInsured,
                    showRequired: isInsured
                },
                [`caLocationPhone${index}`]: {
                    required: isInsured,
                    showRequired: isInsured
                },
                [`caVehicleCounty${index}`]: {
                    availableValues: county.current || [],
                    value: _.get(
                        claimVM,
                        `lobs.commercialAuto.vehicleIncidents.children[${index}].vehicleLocation_Ext.county.value`
                    )
                },
                [`caVehicleCountrySelect${index}`]: {
                    value: _.get(
                        claimVM,
                        `lobs.commercialAuto.vehicleIncidents.children[${index}].vehicleLocation_Ext.country.value`
                    )
                },
                [`caVehicleZipCodeVal${index}`]: {
                    required: isInsured,
                    showRequired: isInsured,
                    visible: isUnitedKingdomChosen(_.get(
                        claimVM,
                        `lobs.commercialAuto.vehicleIncidents.children[${index}].vehicleLocation_Ext`
                    )),
                },
                [`PostcodeInlineLoader${index}`]: {
                    loading: showPostCodeLoader,
                    loadingMessage: 'Fetching address...',
                    visible: showPostCodeLoader
                },
                [`LossLocationOnPostcode${index}`]: {
                    label: 'Addresses for ' + _.get(claimVM, `lobs.commercialAuto.vehicleIncidents.value[${index}].vehicleLocation_Ext.postalCode`),
                    visible: showLookupResult_Ext && !isPostCodeValid(_.get(claimVM, `lobs.commercialAuto.vehicleIncidents.children[${index}].vehicleLocation_Ext`)),
                    availableValues: getMultipleLookupResult(),
                    onValueChange: async (addressIndex) => {
                        await handlePostCodeAddressDropDownValueChange(index, addressIndex);
                    }
                },
                [`caVehiclepostCodeLookupButton${index}`]: {
                    //lino - enable on deploy
                    visible: isUnitedKingdomChosen(_.get(
                        claimVM,
                        `lobs.commercialAuto.vehicleIncidents.children[${index}].vehicleLocation_Ext`
                    )),
                    disabled: isPostCodeValid(_.get(
                        claimVM,
                        `lobs.commercialAuto.vehicleIncidents.children[${index}].vehicleLocation_Ext`
                    )),
                    onTrigger: async (e) => {
                        await lookupClick(index);
                    }
                },
                [`caVehicleLossLocationAddress${index}`]: {
                    onValueChange: (addressIndex) => {
                        handleAddressDropDownValueChange(addressIndex, index);
                    },
                    availableValues: getPreferredAddressDropDownValues(),
                    value: selectedAddressList && selectedAddressList.length >= index ? selectedAddressList[index] : ''
                }

            };
        });

        return Object.assign({}, ...overrides);
    }, [
        claimVM,
        createTypeList,
        generatePassengerTableRow,
        getAvailableDrivers,
        getAvailableYears,
        getDriverValue,
        handleDriverSelect,
        localeService,
        renderAccordionHeader,
        renderTriggerAddPerson,
        updateWizardData,
        writeValue
    ]);
    //conviction table

    const onSelectAllChange = useCallback(
        (event, index) => {
            const elementPath = `lobs.commercialAuto.vehicleIncidents.value[${index}].driver.previousConvictions`;
            const previousConvictions = _.get(claimVM, elementPath);
            selectAllOption.current[index] = event;
            _.forEach(previousConvictions, function (x) {
                if (!x.convictionHeldOnCoronet) {
                    x.select = event;
                }
            });
            updateWizardData(claimVM);
        },
        [claimVM, updateWizardData]
    );
    const getSelectAllCheckBox = (index) => {
        return (
            <CheckboxField
                id={`selectAllCheckBox_${index}`}
                path={selectAllOption.current[index]}
                onValueChange={(e) => onSelectAllChange(e, index)}
                value={selectAllOption.current[index]}
                hideLabel
            />
        );
    };
    const getconvictionHeaderRequired = (item) => {
        return (
            <React.Fragment>
                <span>{item.id === 'convictionDate_Ext' ? 'Conviction Date' : 'Conviction Code'}</span>
                <span className={caClaimStyles.requiredSymbol}>*</span>
            </React.Fragment>
        );
    };
    const getPassengerHeader = (item) => {
        const injuredPath = `lobs.commercialAuto.vehicleIncidents.value[0].passengers[0].injured_Ext`;
        const isInjuredYesSelected = _.get(claimVM, injuredPath);
        if (isInjuredYesSelected) {
            return (
                <React.Fragment>
                    <span>{'Injury Description'}</span>
                </React.Fragment>
            );
        } else {
            return '';
        }

    };
    const getAddConvictionCheckBox = (item, index, property) => {
        let [vehicleIncidentIndex] = (property.path || '').match(/\d+/g) || [];
        vehicleIncidentIndex = Number(vehicleIncidentIndex);
        const elementPath = `lobs.commercialAuto.vehicleIncidents.value[${vehicleIncidentIndex}].driver.previousConvictions[${index}].${property.id}`;
        return (
            <CheckboxField
                id={`${property.id}_${vehicleIncidentIndex}_${index}`}
                path={elementPath}
                onValueChange={writeValue}
                value={item[property.id]}
                disabled={item['convictionHeldOnCoronet']}
                hideLabel
            />
        );
    };
    const getAddConvictionDate = (item, index, property) => {
        let [vehicleIncidentIndex] = (property.path || '').match(/\d+/g) || [];
        const maxDate = new Date();
        vehicleIncidentIndex = Number(vehicleIncidentIndex);
        const elementPath = `lobs.commercialAuto.vehicleIncidents.value[${vehicleIncidentIndex}].driver.previousConvictions[${index}].${property.id}`;
        //               dataType={"string"}
        // format={"long"}
        return (
            <DateField
                id={`${property.id}_${vehicleIncidentIndex}_${index}`}
                path={elementPath}
                onValueChange={writeValue}
                value={item[property.id]}
                disabled={item['convictionHeldOnCoronet']}
                dataType='DD/MM/YYYY'
                separator='/'
                format='abbreviated'
                maxDate={maxDate}
                hideLabel
            />
        );
    };
    const getAddConvictionCode = (item, index, property) => {
        let [vehicleIncidentIndex] = (property.path || '').match(/\d+/g) || [];

        if (convictionCodeList.current === null) {
            let convictionAvailableValues = viewModelService
                .productMetadata
                .get('cc')
                .types
                .getTypelist('ConvictionCode_Ext').codes;
            convictionCodeList.current = convictionAvailableValues.reduce(function (filtered, option) {
                const someNewValue = {
                    code: option.code,
                    name: translator({
                        id: option.name,
                        defaultMessage: option.name
                    })
                };
                if (ismotorClaim.current) {
                    if (vehicleUtils.motorConvictionList.some(f => f === option.code)) {
                        filtered.push(someNewValue);
                    }
                } else {
                    if (option.code !== 'AA00') {
                        filtered.push(someNewValue);
                    }
                }
                return filtered;
            }, []);

        }
        vehicleIncidentIndex = Number(vehicleIncidentIndex);
        const elementPath = `lobs.commercialAuto.vehicleIncidents.value[${vehicleIncidentIndex}].driver.previousConvictions[${index}].${property.id}`;
        return (
            <DropdownSelectField
                id={`${property.id}_${vehicleIncidentIndex}_${index}`}
                path={elementPath}
                availableValues={convictionCodeList.current}
                onValueChange={writeValue}
                value={item[property.id]}
                disabled={item['convictionHeldOnCoronet']}
                hideLabel
            />
        );
    };
    const getAddConvictionPoints = (item, index, property) => {
        let [vehicleIncidentIndex] = (property.path || '').match(/\d+/g) || [];
        vehicleIncidentIndex = Number(vehicleIncidentIndex);
        let pointsArray = [2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
        const elementPath = `lobs.commercialAuto.vehicleIncidents.value[${vehicleIncidentIndex}].driver.previousConvictions[${index}].${property.id}`;
        return (
            <React.Fragment>
                <InputField
                    id={`${property.id}_${vehicleIncidentIndex}_${index}`}
                    path={elementPath}
                    onValueChange={writeValue}
                    value={item[property.id]}
                    disabled={item['convictionHeldOnCoronet']}
                    datalist="convictionPointList"
                    inputType="text"
                    autoComplete={false}
                    className={caClaimStyles.dropdownWidth}
                    placeholder=''
                    hideLabel
                />
                <datalist id="convictionPointList">
                    <option value={'none'} />
                    {pointsArray.map(arrayVal =>
                        <option value={arrayVal} />
                    )}
                </datalist>

            </React.Fragment>
        );
    };
    const getTotalConvictionText = (item, index, property) => {
        return (
            <span>{item[property.id]}</span>
        );
    };

    const showConvictionModalList = () => {
        if (convictionCodeList.current === null) {
            const convictionAvailableValues = viewModelService
                .productMetadata
                .get('cc')
                .types
                .getTypelist('ConvictionCode_Ext').codes;
            convictionCodeList.current = convictionAvailableValues.reduce((filtered, option) => {
                const someNewValue = {
                    code: option.code,
                    name: translator({
                        id: option.name,
                        defaultMessage: option.name
                    })
                };
                if (ismotorClaim.current) {
                    if (vehicleUtils.motorConvictionList.some(f => f === option.code)) {
                        filtered.push(someNewValue);
                    }
                } else {
                    if (option.code !== 'AA00') {
                        filtered.push(someNewValue);
                    }
                }
                return filtered;
            }, []);
        }

        let convictionCodeNames = '';
        convictionCodeList.current.forEach((conviction) => {
            convictionCodeNames = convictionCodeNames + '\n' + conviction.name + '\n';
        });
        ModalNextProvider.showAlert({
            title: messages.convictionListTitle,
            message: convictionCodeNames,
            status: 'info',
            icon: 'mi-info',
            confirmButtonText: messages.postCodeLookupErrorConfirmMessage
        }).catch(_.noop);
    };

    const getTotalConvictionPoints = (item, index, property) => {
        var total = 0;
        const elementPath = `lobs.commercialAuto.vehicleIncidents.value[${index}].driver.previousConvictions`;
        const previousConvictions = _.get(claimVM, elementPath)
        _.forEach(previousConvictions, function (x) {
            if (Number.isInteger(+x.points) && parseInt(x.points) > 0 && parseInt(x.points) < 12) {
                if (parseInt(x.points) == 1) {
                    x.points = 2;
                } else {
                    total += parseInt(x.points);
                }
            } else {
                x.points = null;
            }
        });
        return (
            <span>{total}</span>
        );
    };
    const getAddPassengerDropdown = (item, index, property) => {
        let [vehicleIncidentIndex] = (property.path || '').match(/\d+/g) || [];
        vehicleIncidentIndex = Number(vehicleIncidentIndex);

        const yesNoDropdown = [
            {
                "code": "true",
                "name": {
                    "id": "fnol.ca.directives.vehicle-incident.Yes",
                    "defaultMessage": "Yes"
                }
            },
            {
                "code": "false",
                "name": {
                    "id": "fnol.ca.directives.vehicle-incident.No",
                    "defaultMessage": "No"
                }
            }
        ]
        const elementPath = `lobs.commercialAuto.vehicleIncidents.value[${vehicleIncidentIndex}].passengers[${index}].${property.id}`;
        return (
            <DropdownSelectField
                id={`${property.id}_${vehicleIncidentIndex}_${index}`}
                path={elementPath}
                onValueChange={writeValue}
                availableValues={property.id === 'prefix' ? property.availableValues : yesNoDropdown}
                value={item[property.id]}
                className={caClaimStyles.dropdownWidth}
                hideLabel
            />
        );
    };
    const getInjuryDescription = (item, index, property) => {
        let [vehicleIncidentIndex] = (property.path || '').match(/\d+/g) || [];
        vehicleIncidentIndex = Number(vehicleIncidentIndex);
        const elementPath = `lobs.commercialAuto.vehicleIncidents.value[${vehicleIncidentIndex}].passengers[${index}].${property.id}`;
        const injuredPath = `lobs.commercialAuto.vehicleIncidents.value[${vehicleIncidentIndex}].passengers[${index}].injured_Ext`;
        const injuryDescPath = `lobs.commercialAuto.vehicleIncidents.value[${vehicleIncidentIndex}].passengers[${index}].injuryDescription_Ext`;
        const isInjuredValue = _.get(claimVM, injuredPath);
        let isInjuredYesSelected = false;
        const injuredType = typeof (isInjuredValue);
        if (injuredType === 'boolean') {
            isInjuredYesSelected = isInjuredValue;
        } else {
            isInjuredYesSelected = (isInjuredValue === 'true');
        }
        if (!isInjuredYesSelected) {
            _.set(claimVM, `${injuryDescPath}`, null);
        }
        return (
            <TextAreaField
                id={`${property.id}_${vehicleIncidentIndex}_${index}`}
                path={elementPath}
                onValueChange={writeValue}
                value={item[property.id]}
                rows={3}
                maxLength={1333}
                disabled={!isInjuredYesSelected}
            />

        );
    };
    const getAddPassengerName = (item, index, property) => {
        let [vehicleIncidentIndex] = (property.path || '').match(/\d+/g) || [];
        vehicleIncidentIndex = Number(vehicleIncidentIndex);
        const elementPath = `lobs.commercialAuto.vehicleIncidents.value[${vehicleIncidentIndex}].passengers[${index}].${property.id}`;
        return (
            <InputField
                id={`${property.id}_${vehicleIncidentIndex}_${index}`}
                path={elementPath}
                onValueChange={writeValue}
                value={item[property.id]}
                disabled={!_.isEmpty(item.publicID)}
                hideLabel
            />
        );
    };

    const getAddPassengerPhone = (item, index, property) => {
        let [vehicleIncidentIndex] = (property.path || '').match(/\d+/g) || [];
        vehicleIncidentIndex = Number(vehicleIncidentIndex);
        const elementPath = `lobs.commercialAuto.vehicleIncidents.value[${vehicleIncidentIndex}].passengers[${index}].${property.id}`;
        if (item.cellNumber !== undefined && /[^0-9]/.test(item.cellNumber)) {
            ModalNextProvider.showAlert({
                title: 'Invalid Passenger Phone Number',
                message: 'Please enter a valid phone number. Do not include any special characters or spaces.',
                status: 'info',
                icon: 'mi-info',
                confirmButtonText: 'OK'
            }).catch(_.noop);
        } 
        return (
            <InputField
                id={`${property.id}_${vehicleIncidentIndex}_${index}`}
                path={elementPath}
                onValueChange={writeValue}
                value={item[property.id]}
                disabled={!_.isEmpty(item.publicID)}
                hideLabel
            />
        );
    };

    const removePassengerItem = useCallback(
        (e, index, incidentIndex) => {
            e.preventDefault();
            const newClaimVM = _.clone(claimVM);
            newClaimVM.lobs.commercialAuto.vehicleIncidents.value[incidentIndex].passengers.splice(
                index,
                1
            );
            updateWizardData(newClaimVM);
        },
        [claimVM, updateWizardData]
    );

    const removePassenger = useCallback(
        (item, index, property) => {
            let [vehicleIncidentIndex] = (property.path || '').match(/\d+/g) || [];
            vehicleIncidentIndex = Number(vehicleIncidentIndex);
            return (
                <Link
                    to="/"
                    onClick={(e) => removePassengerItem(e, index, vehicleIncidentIndex)}
                    className={classNames(
                        caClaimStyles.addPersonDeleteSection,
                        caClaimStyles.deleteRow
                    )}
                >
                    <Icon icon="mi-delete" className={caClaimStyles.addPersonRemoveIcon} />
                </Link>
            );
        },
        [removePassengerItem]
    );

    const validateTableForm = useCallback(() => {
        if (
            !claimVM.lobs.commercialAuto.vehicleIncidents.aspects.valid
            || !claimVM.lobs.commercialAuto.vehicleIncidents.aspects.subtreeValid
        ) {
            return false;
        } else if (!checkIfInsuredSelected(claimVM.lobs.commercialAuto.vehicleIncidents.value)) {
            return false;
        }

        return true;
    }, [claimVM]);

    const setIsApplicableForPolicySection = useCallback(() => {
        _.set(claimVM, 'isApplicableForPolicySection_Ext.value', isApplicableForPolicySection_Ext.current);
        updateWizardData(claimVM);
    }, [claimVM, updateWizardData]);

    const addVehicleIncident = useCallback(() => {
        if (claimVM.lobs.commercialAuto.vehicleIncidents.aspects.subtreeValid) {
            claimVM.lobs.commercialAuto.value.createVehicleIncident(claimVM.value);
            updateWizardData(claimVM);
        }
    }, [claimVM, updateWizardData]);

    const validateClaimVM = useCallback(() => {
        return claimVM.aspects.valid && claimVM.aspects.subtreeValid;
    }, [claimVM]);

    useEffect(() => {
        registerComponentValidation(validateClaimVM);
    }, [registerComponentValidation, validateClaimVM]);

    useEffect(() => {
        registerComponentValidation(validateTableForm);
        //onValidate(true);
    }, [registerComponentValidation, validateTableForm,]);

    const overrides = {
        '@field': {
            onValueChange: writeValue,
            showOptional: false
        },
        caVehicleAccordion: {
            size: breakpoint === 'desktop' ? 'medium' : 'small'
        },
        ...generateVehicleOverrides()
    };

    const resolvers = {
        resolveClassNameMap: caClaimStyles,
        resolveComponentMap: {
            vehiclecollision: VehicleDamagePicker,
            contactitemcomponent: FNOLCAContactItemComponent
        },
        resolveCallbackMap: {
            getAddPassengerName: getAddPassengerName,
            getAddPassengerPhone: getAddPassengerPhone,
            getAddPassengerDropdown: getAddPassengerDropdown,
            removePassenger: removePassenger,
            getInjuryDescription: getInjuryDescription,
            addVehicleIncident: addVehicleIncident,
            getSelectAllCheckBox: getSelectAllCheckBox,
            getAddConvictionCheckBox: getAddConvictionCheckBox,
            getAddConvictionDate: getAddConvictionDate,
            getAddConvictionCode: getAddConvictionCode,
            getAddConvictionPoints: getAddConvictionPoints,
            getTotalConvictionText: getTotalConvictionText,
            getTotalConvictionPoints: getTotalConvictionPoints,
            getconvictionHeaderRequired: getconvictionHeaderRequired,
            getPassengerHeader: getPassengerHeader,
            showConvictionModalList: showConvictionModalList
        }
    };

    const readValue = useCallback(
        (id, path) => {
            return readViewModelValue(metadata.pageContent, claimVM, id, path, overrides);
        },
        [claimVM, overrides]
    );

    return (
        <WizardPage
            template={WizardPageTemplate}
            disableNext={!isComponentValid}
            nextButtonID={translator(messages.fnolVehiclePageNextButton)}
        >
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={claimVM}
                resolveValue={readValue}
                overrideProps={overrides}
                onValidationChange={onValidate}
                onModelChange={updateWizardData}
                callbackMap={resolvers.resolveCallbackMap}
                classNameMap={resolvers.resolveClassNameMap}
                componentMap={resolvers.resolveComponentMap}
            />
        </WizardPage>
    );
}

FNOLCAVehiclesPage.propTypes = {
    viewModelService: PropTypes.shape({
        create: PropTypes.func
    }).isRequired
};

FNOLCAVehiclesPage.propTypes = wizardProps;
export default withRouter(FNOLCAVehiclesPage);
